import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as typeList } from "@/api/PMS/communityPartyBuilding/activityType";
import { fetchList, refundAdmin, activeWriteOff, activeWriteOffAll, refund } from "@/api/PMS/orderCharge/orderCharge";
import waves from "@/directive/waves"; // 水波纹指令

import detail from "./detail";
import { formatJson } from "@/utils/index";
export default {
  name: "ComplexTable",
  components: {
    detail: detail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      dates: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      id: -1,
      dialogFormVisible: false,
      activeTypeOption: [],
      exLists: []
    };
  },
  created: function created() {
    this.dates = this.getDateFun();
    this.getTypeOption();
    this.getList();
  },
  methods: {
    getDateFun: function getDateFun() {
      var today = new Date();
      var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return [this.formatDate(firstDayOfMonth), this.formatDate(lastDayOfMonth)];
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
    },
    handleExitDetail: function handleExitDetail(data) {
      this.$router.push({
        path: "/orderInformation/orderCheck",
        query: {
          orderNo: data.orderNo
        }
      });
    },
    outTimeJudge: function outTimeJudge(data) {
      var currentTime = new Date(); // 获取当前时间

      var targetTime = new Date(data); // 设置目标时间

      var timeDifference = Math.abs(currentTime - targetTime); // 计算时间差

      var hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60)); // 计算小时差

      if (hoursDifference >= 24) {
        return true; // console.log("目标时间和当前时间超过24小时");
      } else {
        return false; // console.log("目标时间和当前时间未超过24小时");
      }
    },

    /** 场地/票务：支付时间与当前时间为同一自然日时可退 */
    canRefundSameDay: function canRefundSameDay(paySuccessTime) {
      if (!paySuccessTime) {
        return false;
      }

      var payDate = new Date(paySuccessTime);

      if (isNaN(payDate.getTime())) {
        return false;
      }

      var now = new Date();
      return payDate.getFullYear() === now.getFullYear() && payDate.getMonth() === now.getMonth() && payDate.getDate() === now.getDate();
    },
    getTypeOption: function getTypeOption() {
      var _this = this;

      typeList({
        appType: 1,
        page: 1,
        limit: 9999
      }).then(function (res) {
        if (res.data.code === 200) {
          _this.activeTypeOption = res.data.data;
        }
      });
    },
    handleBack: function handleBack(id) {
      var _this2 = this;

      this.$confirm("你确定是要退款吗, 是否继续?", "提示").then(function (res) {
        refundAdmin({
          orderId: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this2.getList();

            if (response.data.message != null && response.data.message != "") {
              _this2.Alert({
                alertType: "update",
                message: response.data.message
              });
            } else {
              _this2.Alert({
                alertType: "update",
                message: "退款成功"
              });
            }
          }
        });
      });
    },
    handleBackVenue: function handleBackVenue(id) {
      var _this3 = this;

      var row = this.list && this.list.find(function (item) {
        return item.id === id;
      });

      if (row && !this.canRefundSameDay(row.paySuccessTime)) {
        this.Alert({
          alertType: "error",
          message: "仅支持支付当天退款，该订单已超过可退时间"
        });
        return;
      }

      this.$confirm("你确定是要退款吗, 是否继续?", "提示").then(function (res) {
        refund({
          id: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this3.getList();

            if (response.data.message != null && response.data.message != "") {
              _this3.Alert({
                alertType: "update",
                message: response.data.message
              });
            } else {
              _this3.Alert({
                alertType: "update",
                message: "退款成功"
              });
            }
          }
        });
      });
    },
    handleExit: function handleExit(id) {
      var _this4 = this;

      this.$confirm("你确定是要单次核销吗, 是否继续?", "提示").then(function (res) {
        activeWriteOff({
          orderId: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this4.getList();

            if (response.data.message != null && response.data.message != "" && response.data.message != "success") {
              _this4.Alert({
                alertType: "update",
                message: response.data.message
              });
            } else {
              _this4.Alert({
                alertType: "update",
                message: "核销成功"
              });
            }
          }
        });
      });
    },
    handleAllExit: function handleAllExit(id) {
      var _this5 = this;

      this.$confirm("你确定是要全部核销吗, 是否继续?", "提示").then(function (res) {
        activeWriteOffAll({
          orderId: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this5.getList();

            if (response.data.message != null && response.data.message != "" && response.data.message != "success") {
              _this5.Alert({
                alertType: "update",
                message: response.data.message
              });
            } else {
              _this5.Alert({
                alertType: "update",
                message: "核销成功"
              });
            }
          }
        });
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this6 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this6.list = response.data.data;
        _this6.total = response.data.total;
        _this6.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDetail: function handleDetail(id) {
      this.id = id;
      this.title = "订单详情";
      this.dialogFormVisible = true;
    },
    // 导出
    handleExport: function handleExport() {
      var _this7 = this;

      this.exLists = [];
      this.$confirm("你确定要导出支付订单数据吗, 是否继续?", "提示").then(function () {
        fetchList({
          businessType: _this7.listQuery.businessType,
          orderNo: _this7.listQuery.orderNo,
          orderName: _this7.listQuery.orderName,
          status: _this7.listQuery.status,
          stuName: _this7.listQuery.stuName,
          stuTel: _this7.listQuery.stuTel,
          beginDate: _this7.listQuery.beginDate,
          endDate: _this7.listQuery.endDate,
          content: _this7.listQuery.content
        }).then(function (response) {
          _this7.exLists = response.data.data;

          _this7.exLists.forEach(function (element) {
            switch (element.isCheck) {
              case "0":
                if (element.status == 1) {
                  element.isCheck = "-";
                } else {
                  element.isCheck = "未核销";
                }

                break;

              case "1":
                element.isCheck = "已核销";
                break;

              case "2":
                element.isCheck = "部分核销";
                break;

              default:
                break;
            }

            switch (element.status) {
              case 1:
                element.status = "待支付";
                break;

              case 2:
                element.status = "已支付";
                break;

              case 3:
                element.status = "退款中";
                break;

              case 4:
                element.status = "已退款";
                break;

              default:
                break;
            }

            switch (element.businessType) {
              case "1":
                element.businessType = "培训活动";
                break;

              case "2":
                element.businessType = "场地预定";
                break;

              case "3":
                element.businessType = "共享空间";
                break;

              case "4":
                element.businessType = "演艺票务";
                break;

              case "5":
                element.businessType = "游泳票务";
                break;

              default:
                break;
            }
          });

          if (_this7.exLists !== null && _this7.exLists.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["订单编号", "项目类型", "项目名称", "报名内容", "微信昵称", "姓名", "联系方式", "订单状态", "订单总金额(元)", "订单创建时间", "订单支付时间", "退款时间", "核销次数", "核销状态"];
              var fileterVal = ["orderNo", "businessType", "orderName", "content", "openName", "stuName", "stuTel", "status", "orderAmount", "createTime", "paySuccessTime", "refundTime", "chickNum", "isCheck"];
              var data = formatJson(fileterVal, _this7.exLists);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "支付订单信息",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this7.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};